import { render, staticRenderFns } from "./msCellNumber.vue?vue&type=template&id=52dbfac0&scoped=true"
import script from "./msCellNumber.vue?vue&type=script&lang=js"
export * from "./msCellNumber.vue?vue&type=script&lang=js"
import style0 from "./msCellNumber.vue?vue&type=style&index=0&id=52dbfac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dbfac0",
  null
  
)

export default component.exports